import { array } from "joi";
import store from "../index";

const state = () => ({
  //Customers
  customers: { options: [], label: "" },
  selectedCustomers: "",
  customersSelectArray: [],
  customersOptions: [{}],
  customersOptionsStrings: [],
  customersMainOptions: [{}],
  customersMainOptionsStrings: [],
  //KvkNumber
  kvkNumbers: {options: [], label: ""},
  kvkNumbersOptions: [],
  selectedKvkNumbers: [],
  //SBI code
  sbiCodes: {options: [], label: ""},
  sbiCodesOptions: [],
  selectedSbiCodes: [],
  //Municipality
  isMunicipality: false,
  //Organisations
  organisations: { options: [], label: "" },
  selectedOrganisations: "",
  organisationsSelectArray: [],
  organisationsOptions: [{}],
  organisationsOptionsStrings: [],
  //Subjects
  subjects: { options: [], label: "" },
  selectedSubjects: "",
  subjectsSelectArray: [],
  subjectsOptions: [{}],
  subjectsOptionsStrings: [],
  //Publish date
  daysRange: {
    from: "",
    to: "",
  },
  //Years picker
  years: { options: [], label: "" },
  selectedYears: "",
  yearsSelectArray: [],
  yearsOptions: [{}],
  yearsOptionsStrings: [],
  //Scopes
  scopesOptions: [
    { id: 10, name: "European" },
    { id: 20, name: "National" },
    { id: 30, name: "Regional" },
  ],
  selectedScopes: [],
  selectedScopesIds: "",

  //Main (me) customer
  selectedMainCustomer: null,
  selectedMainCustomerId: [],
  allSelectedCustomersArray: [],
  newSelectedCustomer: {},
});

const getters = {};

const actions = {};

const mutations = {
  updateAllCustomersArray(state) {
    state.allSelectedCustomersArray = [];
  
    if(state.customersSelectArray){
      state.customersSelectArray.forEach(customer => {
        customer.ids.forEach(id => {
          let newCustomer = { ...state.newSelectedCustomer, id, label: customer.label };
          state.allSelectedCustomersArray.push(newCustomer);
        });
      });
    }
    if (state.selectedMainCustomer) {
      state.selectedMainCustomer.ids.forEach(id => {
        let newCustomer = { ...state.selectedMainCustomer, id };
        state.allSelectedCustomersArray.push(newCustomer);
      });
    }
  },
  //Municipality
  updateIsMunicipality(state,val) {
    state.isMunicipality = val;
  },
    //Scopes
  setSelectedScopes(state, val) {
    state.selectedScopes = val;
    state.selectedScopesIds = "";
    if (state.selectedScopes != null)
      for (
        let i = 0;
        i < state.selectedScopes.length;
        i++ //   state.selectedScopesIds.push(state.selectedScopes[i].name);
      ) {
        state.selectedScopesIds += state.selectedScopes[i].name + ",";
      }
    if (state.selectedScopesIds[state.selectedScopesIds.length - 1] == ",")
      state.selectedScopesIds = state.selectedScopesIds.substring(
        0,
        state.selectedScopesIds.length - 1
      );
  },
  //Customers
  setCustomersFilters(state, val) {
    state.customers = val;
  },
  updateSelectedCustomers(state, val) {
    state.customersSelectArray = val;
  },

  createCustomersOptions(state) {
    state.customersOptions = [];
    for (let i = 0; i < state.customers.options.length; i++) {
      state.customersOptions.push({
        id: state.customers.options[i].id,
        label: state.customers.options[i].label,
        ids: state.customers.options[i].ids,
      });
      if (
        state.customers.options[i].children &&
        state.customers.options[i].children.length
      ) {
        for (let j = 0; j < state.customers.options[i].children.length; j++)
          state.customersOptions.push({
            id: state.customers.options[i].children[j].id,
            label:
              state.customers.options[i].label +
              "," +
              state.customers.options[i].children[j].label,
            parent: state.customers.options[i],
          });
      }
    }
    state.customersMainOptions = state.customersOptions;
  },
  createCustomersOptionsString(state) {
    state.customersOptionsStrings = [];
    for (let i = 0; i < state.customers.options.length; i++) {
      state.customersOptionsStrings.push(state.customers.options[i].label);
      if (
        state.customers.options[i].children &&
        state.customers.options[i].children.length
      ) {
        for (let j = 0; j < state.customers.options[i].children.length; j++)
          state.customersOptionsStrings.push(
            state.customers.options[i].children[j].label
          );
      }
    }

    state.customersMainOptionsStrings = state.customersOptionsStrings;
  },
  //Main (me) customer
  setMainCustomersFilters(state, val) {
    state.mainCustomers = val;
  },
  createMainCustomersOptions(state) {
    state.customersMainOptions = [];
    for (let i = 0; i < state.mainCustomers.options.length; i++) {
      state.customersMainOptions.push({
        id: state.mainCustomers.options[i].id,
        label: state.mainCustomers.options[i].label,
        ids: state.mainCustomers.options[i].ids,
      });
      if (
        state.mainCustomers.options[i].children &&
        state.mainCustomers.options[i].children.length
      ) {
        for (let j = 0; j < state.mainCustomers.options[i].children.length; j++)
          state.customersMainOptions.push({
            id: state.mainCustomers.options[i].children[j].id,
            label:
              state.mainCustomers.options[i].label +
              "," +
              state.mainCustomers.options[i].children[j].label,
            parent: state.mainCustomers.options[i],
          });
      }
    }
  },
  createMainCustomersOptionsString(state) {
    state.customersMainOptionsStrings = [];
    for (let i = 0; i < state.mainCustomers.options.length; i++) {
      state.customersMainOptionsStrings.push(
        state.mainCustomers.options[i].label
      );
      if (
        state.mainCustomers.options[i].children &&
        state.mainCustomers.options[i].children.length
      ) {
        for (let j = 0; j < state.mainCustomers.options[i].children.length; j++)
          state.customersMainOptionsStrings.push(
            state.mainCustomers.options[i].children[j].label
          );
      }
    }
  },
  removePreviousMainCustomer(state) {
    var index = state.selectedCustomers.indexOf(state.selectedMainCustomer);
    if (index > -1) array.splice(index, 1);
  },
  updateSelectedMainCustomer(state, val) {
    if (val == null) {
      store.commit("fomoStatisticsSearch/removePreviousMainCustomer");
      state.selectedMainCustomer = null;
      state.selectedMainCustomerId = 0;
    } else {
      state.selectedMainCustomer = val;
      state.selectedMainCustomerId = val.ids;
    }
    /*     this.commit('fomoStatisticsSearch/updateSelectedCustomersString');
     */
  },

  //kvkNumber
  setKvkNumbers(state, val){
    state.kvkNumbers = val;
  },
  createKvkNumberOptions(state){
    state.kvkNumbersOptions = [];
    for (let i = 0; i < state.kvkNumbers.options.length; i++) {
      state.kvkNumbersOptions.push({
        id: state.kvkNumbers.options[i].id,
        label: state.kvkNumbers.options[i].label,
        ids: state.kvkNumbers.options[i].ids,
      });
      if (
        state.kvkNumbers.options[i].children &&
        state.kvkNumbers.options[i].children.length
      ) {
        for (let j = 0; j < state.kvkNumbers.options[i].children.length; j++)
          state.kvkNumbersOptions.push({
            id: state.kvkNumbers.options[i].children[j].id,
            label:
              state.kvkNumbers.options[i].label +
              "," +
              state.kvkNumbers.options[i].children[j].label,
            parent: state.kvkNumbers.options[i],
          });
      }
    }
  },
  updateSelectedKvkNumbers(state, val){
    state.selectedKvkNumbers = val;
  },

  //SBI codes
  setSbiCodes(state,val){
    state.sbiCodes = val;
  },
  createSbiCodeOptions(state){
    state.sbiCodesOptions = [];
    for (let i = 0; i < state.sbiCodes.options.length; i++) {
      state.sbiCodesOptions.push({
        id: state.sbiCodes.options[i].id,
        label: state.sbiCodes.options[i].label,
        ids: state.sbiCodes.options[i].ids,
      });
      if (
        state.sbiCodes.options[i].children &&
        state.sbiCodes.options[i].children.length
      ) {
        for (let j = 0; j < state.sbiCodes.options[i].children.length; j++)
          state.sbiCodesOptions.push({
            id: state.sbiCodes.options[i].children[j].id,
            label:
              state.sbiCodes.options[i].label +
              "," +
              state.sbiCodes.options[i].children[j].label,
            parent: state.sbiCodes.options[i],
          });
      }
    }
  },
  
  updateSelectedSbiCodes(state,val){
    state.selectedSbiCodes = val;
  },

  //Organisations
  setOrganisationsFilters(state, val) {
    state.organisations = val;
  },
  updateSelectedOrganisations(state, val) {
    state.organisationsSelectArray = val;
    this.commit("fomoStatisticsSearch/updateSelectedOrganisationsString");
  },
  updateSelectedOrganisationsString(state) {
    state.selectedOrganisations = "";

    if (
      state.organisationsSelectArray &&
      state.organisationsSelectArray.length > 0
    ) {
      for (let i = 0; i < state.organisationsSelectArray.length; i++) {
        state.selectedOrganisations +=
          state.organisationsSelectArray[i].id + ",";
      }
      if (
        state.selectedOrganisations[state.selectedOrganisations.length - 1] ==
        ","
      )
        state.selectedOrganisations = state.selectedOrganisations.substring(
          0,
          state.selectedOrganisations.length - 1
        );
    }
  },
  createOrganisationsOptions(state) {
    state.organisationsOptions = [];
    for (let i = 0; i < state.organisations.options.length; i++) {
      state.organisationsOptions.push({
        id: state.organisations.options[i].id,
        label: state.organisations.options[i].label,
      });
      if (
        state.organisations.options[i].children &&
        state.organisations.options[i].children.length
      ) {
        for (let j = 0; j < state.organisations.options[i].children.length; j++)
          state.organisationsOptions.push({
            id: state.organisations.options[i].children[j].id,
            label:
              state.organisations.options[i].label +
              "," +
              state.organisations.options[i].children[j].label,
            parent: state.organisations.options[i],
          });
      }
    }
  },
  createOrganisationsOptionsString(state) {
    state.organisationsOptionsStrings = [];
    for (let i = 0; i < state.organisations.options.length; i++) {
      state.organisationsOptionsStrings.push(
        state.organisations.options[i].label
      );
      if (
        state.organisations.options[i].children &&
        state.organisations.options[i].children.length
      ) {
        for (let j = 0; j < state.organisations.options[i].children.length; j++)
          state.organisationsOptionsStrings.push(
            state.organisations.options[i].children[j].label
          );
      }
    }
  },
  //Subjects
  setSubjectsFilters(state, val) {
    state.subjects = val;
  },
  updateSelectedSubjects(state, val) {
    state.subjectsSelectArray = val;
    this.commit("fomoStatisticsSearch/updateSelectedSubjectsString");
  },
  updateSelectedSubjectsString(state) {
    state.selectedSubjects = "";
    if (state.subjectsSelectArray && state.subjectsSelectArray.length > 0) {
      for (let i = 0; i < state.subjectsSelectArray.length; i++) {
        state.selectedSubjects += state.subjectsSelectArray[i].id + ",";
      }
      if (state.selectedSubjects[state.selectedSubjects.length - 1] == ",")
        state.selectedSubjects = state.selectedSubjects.substring(
          0,
          state.selectedSubjects.length - 1
        );
    }
  },
  createSubjectsOptions(state) {
    state.subjectsOptions = [];
    for (let i = 0; i < state.subjects.options.length; i++) {
      state.subjectsOptions.push({
        id: state.subjects.options[i].id,
        label: state.subjects.options[i].label,
      });
      if (
        state.subjects.options[i].children &&
        state.subjects.options[i].children.length
      ) {
        for (let j = 0; j < state.subjects.options[i].children.length; j++)
          state.subjectsOptions.push({
            id: state.subjects.options[i].children[j].id,
            label:
              state.subjects.options[i].label +
              "," +
              state.subjects.options[i].children[j].label,
            parent: state.subjects.options[i],
          });
      }
    }
  },
  createSubjectsOptionsString(state) {
    state.subjectsOptionsStrings = [];
    for (let i = 0; i < state.subjects.options.length; i++) {
      state.subjectsOptionsStrings.push(state.subjects.options[i].label);
      if (
        state.subjects.options[i].children &&
        state.subjects.options[i].children.length
      ) {
        for (let j = 0; j < state.subjects.options[i].children.length; j++)
          state.subjectsOptionsStrings.push(
            state.subjects.options[i].children[j].label
          );
      }
    }
  },
  //Publish date
  updateDaysRange(state, val) {
    state.daysRange.from = val.from;
    state.daysRange.to = val.to;
  },
  //Years picker
  setYearsFilters(state, val) {
    state.years = val;
  },
  updateSelectedYears(state, val) {
    state.yearsSelectArray = val;
    this.commit("fomoStatisticsSearch/updateSelectedYearsString");
  },
  updateSelectedYearsString(state) {
    state.selectedYears = "";

    if (state.yearsSelectArray && state.yearsSelectArray.length > 0) {
      for (let i = 0; i < state.yearsSelectArray.length; i++) {
        state.selectedYears += state.yearsSelectArray[i].id + ",";
      }
      if (state.selectedYears[state.selectedYears.length - 1] == ",")
        state.selectedYears = state.selectedYears.substring(
          0,
          state.selectedYears.length - 1
        );
    }
  },
  createYearsOptions(state) {
    state.yearsOptions = [];
    for (let i = 0; i < state.years.options.length; i++) {
      state.yearsOptions.push({
        id: state.years.options[i].id,
        label: state.years.options[i].label,
      });
      if (
        state.years.options[i].children &&
        state.years.options[i].children.length
      ) {
        for (let j = 0; j < state.years.options[i].children.length; j++)
          state.yearsOptions.push({
            id: state.years.options[i].children[j].id,
            label:
              state.years.options[i].label +
              "," +
              state.years.options[i].children[j].label,
            parent: state.years.options[i],
          });
      }
    }
  },
  createYearsOptionsString(state) {
    state.yearsOptionsStrings = [];
    for (let i = 0; i < state.years.options.length; i++) {
      state.yearsOptionsStrings.push(state.years.options[i].label);
      if (
        state.years.options[i].children &&
        state.years.options[i].children.length
      ) {
        for (let j = 0; j < state.years.options[i].children.length; j++)
          state.yearsOptionsStrings.push(
            state.years.options[i].children[j].label
          );
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
